import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { cloneDeep } from 'lodash'
import { Col, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { isFormRequired, isFormError, formValidation, isFormDisabled, formatDateTime } from 'helpers/format'
import { CreateReq, DetailReq, UpdateReq, ProductOptions as ProductOptionsTypes } from 'Store/product/types'
import { createProductAPI, getProductDetailAPI, updateProductAPI } from 'Store/product/api'
import { selectActionEvent, selectDetail, selectDetailEvent } from 'Store/product/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { MultiUploadForm } from 'Components/form'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/product/actions'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import { ProductStatus } from 'helpers/constanst'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Data as CateData } from 'Store/categories/types'
import { Data as UomData } from 'Store/uom/types'
import { Data as ManufactuerData } from 'Store/manufactuer/types'
import ProductInfo from './components/ProductInfo'
import DeliveryType from './components/DeliveryType'
import ProductSetting from './components/ProductSetting'
import ProductOptions from './components/ProductOptions'
import RequestHistoryDrawer from './components/RequestHistoryDrawer'
import { appConfig, themeConfig } from 'config'
import { ConfirmDailog, ConfirmQuestion } from 'Components/modal'
import { selectDatas as selectDeliveryDatas } from 'Store/delivery-cost/selector'
import { selectIsHasPackageC, selectIsPackageC } from 'Store/pos/selector'
import { getUserLogin } from 'helpers/account'
import { TutoriaProductPage } from 'helpers/tutorials'
import { AppTutorial } from 'Components/utilities'
import Label from 'Components/text/Label'

interface MasterData {
  categories?: CateData[]
  uoms?: UomData[]
  manufacturers?: ManufactuerData[]
}

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  mode: any
  id?: number
  masterData?: MasterData
}

const CouponDetail: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    id = 0,
    mode,
    detail,
    detailEvent,
    masterData,
    deliveryCost,
    isPackageC,
    isHasPackage,
  } = props
  const isCreateMode = mode === 'create'
  const userInfo = getUserLogin()
  const enableProductOnline = themeConfig?.component?.elementOnlineProduct
  let onlineDefaultStatus = ProductStatus.ACTIVE
  if (!enableProductOnline) {
    onlineDefaultStatus = ProductStatus.INACTIVE
  }
  if (isPackageC) {
    onlineDefaultStatus = ProductStatus.INACTIVE
  }

  const initForm = {
    product_options: [] as ProductOptionsTypes[],
    category_id: 0,
    code: '',
    details: '',
    photos: [],
    manufacturer_id: 0,
    group_id: 0,
    status: onlineDefaultStatus,
    status_pos: ProductStatus.ACTIVE,
    title: '',
    instruction: '',
    uom_id: 0,
    model: '',
    refund_status: 'off',
    product_refund_unit: 'months',
    sub_category_id: 0,
    warranty_status: 'off',
    product_warranty_unit: 'months',
    deliver_status: 'baandy',
    shipping_types: ['pickup'],
    bom: 100,
  } as CreateReq
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [formError, setFormError] = useState([] as string[])
  const [confirmFirstDialog, setConfirmFirstDialog] = useState(false)
  const [confirmRequestDialog, setConfirmRequestDialog] = useState(false)
  const [showRequestedHistories, setShowRequestedHistories] = useState(false)
  const isSupperAdmin = currentUser?.activeMerchant?.id === parseInt(appConfig.merchantID || '')
  const isFranchise = currentUser?.activeMerchant?.is_fc === true
  const disableInput = (!detail?.is_created && detail?.first_update) || isFranchise
  const dispatch = useDispatch()

  // tutorial
  const [showTutorial, setShowTutorial] = useState(false as boolean)
  const steps = TutoriaProductPage.detail.steps
  const enableTutorial = TutoriaProductPage.detail.enable

  const requireFeild = [
    'photos',
    'code',
    'title',
    'group_id',
    'category_id',
    'sub_category_id',
    'manufacturer_id',
    'uom_id',
    'details',
    'warranty_status',
    'product_warranty_unit',
    'refund_status',
    'product_refund_unit',
    'shipping_types',
    'product_options',
  ]

  const disableFirstUpdate = [
    'photos',
    'title',
    'group_id',
    'category_id',
    'sub_category_id',
    'manufacturer_id',
    'uom_id',
    'details',
    'manual',
    'maintenant_and_caution',
    'properties',
    'refund_status',
    'warranty_status',
    'model',
    'product_options_add',
    'product_options_delete',
    'product_options_clone',
    'product_options_detail',
  ]

  const disableFranchise = [
    'photos',
    'title',
    'group_id',
    'category_id',
    'sub_category_id',
    'manufacturer_id',
    'uom_id',
    'details',
    'manual',
    'maintenant_and_caution',
    'properties',
    'refund_status',
    'warranty_status',
    'model',
    'product_options_add',
    'product_options_delete',
    'product_options_clone',
    'product_options_detail',
    'code',
  ]

  const hasWarranty = formData.warranty_status === 'on'
  const hasRefund = formData.refund_status === 'on'

  useEffect(() => {
    // clear form data when user cloase drawer
    if (!visible) {
      setFormData(cloneDeep({ ...initForm }))
      setFormError([])
    }
    // get banner detail on "edit" mode
    if (visible && !isCreateMode && id > 0) {
      onGetDetail()
    }
    if (visible && isCreateMode) {
      setFormData({ ...initForm })
    }
  }, [visible])

  useEffect(() => {
    if (mode === 'edit' && id > 0) {
      const form = {
        ...detail,
        bom: detail?.bom || 0,
        status: enableProductOnline ? detail?.status : ProductStatus.INACTIVE,
        deliver_status: 'baandy',
      } as CreateReq
      setFormData({ ...form })
    }
  }, [detail])

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  const mappingReq = (req: CreateReq) => {
    req.product_options = (req?.product_options || []).map(item => {
      if (item?.id && item.id.toString().includes('new')) {
        item.id = 0
      }
      item.quantity_offline = item?.quantity_offline || 0
      return item
    })
    return req
  }

  const getDeleteList = (req: UpdateReq) => {
    const deleteList = [] as number[]
    detail?.product_options &&
      detail?.product_options.forEach((originalOption: ProductOptionsTypes) => {
        const result = req?.data?.product_options.find(
          (option: ProductOptionsTypes) => option.id === originalOption.id,
        )
        if (!result) {
          deleteList.push(originalOption.id)
          req.data?.product_options.push({
            ...originalOption,
            delete: true,
          })
        }
      })
    return req
  }

  const onCreate = (): void => {
    if (!validateForm()) return
    const data = mappingReq(cloneDeep(formData))
    const req: CreateReq = {
      ...data,
      merchant_id: currentUser?.activeMerchant?.id || 0,
      bom: data.bom === 100 ? 0 : data.bom,
    }
    dispatch(createProductAPI({ data: req }, currentUser.accessToken))
  }

  const onGetDetail = (): void => {
    const req: DetailReq = {
      id,
      is_admin: true,
    }
    dispatch(getProductDetailAPI(req, currentUser.accessToken))
  }

  const onUpdate = (update_remark: string = ''): void => {
    if (!validateForm()) return
    const data = mappingReq(cloneDeep(formData))
    let req: UpdateReq = {
      data: {
        ...data,
        distance_delivery_config_id:
          data.shipping_types?.includes('shop_delivery') || data.shipping_types?.includes('special_delivery')
            ? data.distance_delivery_config_id
            : deliveryCost && deliveryCost[0]?.id,
      },
      id,
      update_remark,
      request_action_by: userInfo?.username || '',
    }
    req = getDeleteList(req)
    console.log('update_remark', update_remark)
    dispatch(updateProductAPI(req, currentUser.accessToken))
  }

  const onClickUpdate = () => {
    if (!validateForm()) return
    if (isSupperAdmin) {
      // Banndy can update always, not need to approve by admin
      onUpdate()
    } else {
      if (!detail?.is_created && detail?.first_update) {
        // First time update for product imported
        // 1. User can be update all feild
        // 2. Will display dialog before confirm
        onOpenConfirmFirstUpdate()
      } else {
        // Not first time update for product imported or product created by user
        // 1.product imported : user can update some feild -->
        // 2.Need "update_remark" before send request for update
        onOpenConfirmRequestUpdate()
      }
    }
  }

  const onUpdateData = (val: any, key: string) => {
    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)

    if (hasRefund && (formData?.product_refund || 0) <= 0) {
      error.push('product_refund')
    }
    if (hasWarranty && (formData?.product_warranty || 0) <= 0) {
      error.push('product_warranty')
    }
    let inactiveAll = true
    if (formData.product_options) {
      formData.product_options.forEach(item => {
        if (item.price <= 0) {
          error.push('product_price')
          return
        }
      })

      formData.product_options.forEach(item => {
        if (item.publish) {
          inactiveAll = false
          return
        }
      })
    }

    if (inactiveAll) {
      error.push('product_options_status')
    }

    if (
      formData.shipping_types?.includes('special_delivery') ||
      formData.shipping_types?.includes('shop_delivery')
    ) {
      if ((formData?.distance_delivery_config_id || 0) <= 0) {
        error.push('distance_delivery_config_id')
      }
    }

    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
    onCloseConfirmFirstUpdate()
    onCloseConfirmRequestUpdate()
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const isDisabled = (name: string) => {
    return (
      (disableInput && isFormDisabled(isFranchise ? disableFranchise : disableFirstUpdate, name)) || false
    )
  }

  const onOpenConfirmFirstUpdate = () => {
    setConfirmFirstDialog(true)
  }

  const onCloseConfirmFirstUpdate = () => {
    setConfirmFirstDialog(false)
  }

  const onOpenConfirmRequestUpdate = () => {
    setConfirmRequestDialog(true)
  }

  const onCloseConfirmRequestUpdate = () => {
    setConfirmRequestDialog(false)
  }

  const FooterContent = (
    <Space size="middle" align="baseline" className="ttr-save">
      <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
      {isCreateMode ? (
        <PrimaryButton text="ยืนยันการสร้าง" onClick={onCreate} />
      ) : (
        <PrimaryButton text="ยืนยันการแก้ไขข้อมูล" onClick={onClickUpdate} />
      )}
    </Space>
  )

  const title = (
    <>
      <Row justify="start" gutter={16} align="middle">
        <Col>{isCreateMode ? 'สร้างสินค้าใหม่' : 'แก้ไขข้อมูลสินค้า'}</Col>
        {!isCreateMode && !isSupperAdmin && (
          <Col>
            {/* <ActionButton
              text=""
              icon={<FileDoneOutlined />}
              label="ประวัติการแก้ไข"
              action="edit"
              onClick={() => setShowRequestedHistories(true)}
            /> */}
            <LinkStyle onClick={() => setShowRequestedHistories(true)}>ประวัติการแก้ไข</LinkStyle>
          </Col>
        )}
      </Row>
      {!isCreateMode && (
        <Row>
          <Col>
            <Description>รหัสสินค้า {detail?.id}</Description> &nbsp;
            <Description>วันที่สร้าง {formatDateTime(detail?.created_at || '')}</Description>
          </Col>
        </Row>
      )}
    </>
  )

  const requestHistory = (
    <RequestHistoryDrawer
      isShow={showRequestedHistories}
      onClose={() => setShowRequestedHistories(false)}
      productID={detail?.id || 0}
    />
  )

  const ConfirmFirstUpdateModal = (
    <ConfirmDailog
      isShow={confirmFirstDialog}
      handleOk={onUpdate}
      handleCancel={onCloseConfirmFirstUpdate}
      title="ยืนยันแก้ไขข้อมูล"
      description="เพื่อความรวดเร็วและอำนวยความสะดวกในการนำข้อมูลเข้า กรุณาตรวจสอบราคาสินค้า และสถานะการแสดงบนเว็ปให้ถูกต้องนะคะ"
      loading={event.IsLoading}
      confirmBtnTxt="แก้ไขข้อมูล"
    />
  )

  const ConfirmRequestUpdate = (
    <ConfirmQuestion
      title="ยืนยันแก้ไขข้อมูล"
      description="หมายเหตุ : ข้อมูลสินค้าของคุณจะถูกเปลี่ยนแปลง หลังจากผู้ดูแลระบบตรวจสอบและอนุมัติแล้วนะคะ"
      label="กรุณาระบุรายละเอียดการแก้ไข"
      placeholder="เช่น แก้ไขราคาสินค้า..."
      confirmBtnTxt="แก้ไขข้อมูล"
      isShow={confirmRequestDialog}
      handleOk={(remark: string) => onUpdate(remark)}
      handleCancel={onCloseConfirmRequestUpdate}
      loading={event.IsLoading}
    />
  )

  return (
    <DetailDrawer
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      //visible={true}
      footer={FooterContent}
      width={'80%'}
      isShowTutorial={showTutorial}
      showTutorial={enableTutorial}
      onClickStart={() => setShowTutorial(true)}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal
        event={[event]}
        enable={visible}
        successCalback={onEventSuccess}
        errorCalback={clearEvent}
      />
      <Row justify="space-between" gutter={16}>
        <Col md={24} xs={24}>
          <MultiUploadForm
            label="รูปภาพสินค้า"
            token={currentUser.accessToken}
            onUpdateData={onUpdateData}
            files={formData.photos || []}
            folder="product"
            listType="picture-card"
            isPrivate={true}
            acceptType="image/png,image/jpeg"
            withCropImage={true}
            aspect={1}
            name="photos"
            description="ขนาดไฟล์รูปสินค้าที่อัปโหลดต้องมีขนาด 40KB - 10.24 MB (.png .jpeg)"
            isRequired={isRequired('photos')}
            isError={isError('photos')}
            key="photos-product"
            minFileSize={40}
            maxFileSize={10240}
            isCompress={true}
            readOnly={isDisabled('photos')}
            className="ttr-upload-img"
          />
        </Col>
        <Col md={24} xs={24}>
          <Title className="ttr-product-info">ข้อมูลสินค้า</Title>
          <ProductInfo
            formData={formData}
            setFormData={setFormData}
            onUpdateData={onUpdateData}
            categories={masterData?.categories || []}
            uoms={masterData?.uoms || []}
            manufacturers={masterData?.manufacturers || []}
            isError={isError}
            isRequired={isRequired}
            isDisabled={isDisabled}
            isCreateMode={isCreateMode}
            isPackageC={isPackageC}
          />
          <ProductOptions
            formData={formData}
            onUpdateData={onUpdateData}
            isError={isError}
            isRequired={isRequired}
            isDisabled={isDisabled}
            isPackageC={isPackageC}
            uom={masterData?.uoms?.find(item => item.id === formData.uom_id)?.name || ''}
          />
          {enableProductOnline && (
            <div className="ttr-delivery">
              <Title>ช่องทางการจัดส่ง</Title>
              <DeliveryType
                formData={formData}
                onUpdateData={onUpdateData}
                isError={isError}
                deliveryCostData={deliveryCost}
              />
            </div>
          )}
          <div className="ttr-setting">
            <Title>ตั้งค่าสินค้า</Title>
            <ProductSetting
              formData={formData}
              onUpdateData={onUpdateData}
              isError={isError}
              isRequired={isRequired}
              isDisabled={isDisabled}
              isHasPackage={isHasPackage}
            />
          </div>
        </Col>
      </Row>
      {!isCreateMode && requestHistory}
      {detail?.first_update && ConfirmFirstUpdateModal}
      {ConfirmRequestUpdate}
      {enableTutorial && (
        <AppTutorial
          onCloaseTutorial={() => setShowTutorial(false)}
          showTutorial={showTutorial}
          steps={steps}
        />
      )}
    </DetailDrawer>
  )
}

const Title = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  font-weight: 500;
`

const Description = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const LinkStyle: any = styled(Label)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  text-decoration: underline;
  cursor: pointer;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
    detail: selectDetail(state),
    detailEvent: selectDetailEvent(state),
    deliveryCost: selectDeliveryDatas(state),
    isPackageC: selectIsPackageC(state),
    isHasPackage: selectIsHasPackageC(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(CouponDetail)
